import axios from 'axios'

export default {
    install(Vue, vm) {

        function getConstitution(name) {
            let url = `${vm.baseUrl}/app/constitution?name=${name}`
            return axios.post(url)
        }

        function getMeridian(name) {
            let url = `${vm.baseUrl}/app/meridian?name=${name}`
            return axios.post(url)
        }

        // 暴露方法到 vm
        Vue.prototype.$http = {
            getConstitution,
            getMeridian,
        }

        console.log(vm)

    }
};
